const selectors = {
  groupTriggers: ".group_trigger",
  blogFilterContainers: ".section__blog__filters__listing",
  sectionAboveDropdown: ".section__blog__header-recommended",
  sectionBelowDropdown: ".section__blog__filters+.lyt__container",
  filterDropdownContainers: ".section__blog__filters__filter__content"
};


export default function init ({ el, context }) {

  const nodeSelectors = {
    groupTriggers: document.querySelectorAll(selectors.groupTriggers),
    blogFilterContainers: document.querySelectorAll(selectors.blogFilterContainers),
    filterDropdownContainers: document.querySelectorAll(selectors.filterDropdownContainers),
    sectionAboveDropdown: document.querySelector(selectors.sectionAboveDropdown),
    sectionBelowDropdown: document.querySelector(selectors.sectionBelowDropdown)
  };

  nodeSelectors.groupTriggers.forEach(filter => {
    filter.addEventListener('click', e => {
      e.preventDefault();
      let thisTrigger = e.currentTarget;
      let dropdownContainer = thisTrigger.nextElementSibling;

      if (dropdownContainer.getAttribute("aria-hidden") === "true") {
        closeDropdowns();
        thisTrigger.classList.add("active");
        dropdownContainer.setAttribute("aria-hidden", false);
      } else {
        closeDropdowns();
      }
    })
  })

  nodeSelectors.sectionAboveDropdown.addEventListener('click', e => {
    console.log('Section Above');
    closeDropdowns();
  })
  
  nodeSelectors.sectionBelowDropdown.addEventListener('click', e => {
    console.log('Section Below');
    closeDropdowns();
  })

  function closeDropdowns() {
    nodeSelectors.groupTriggers.forEach( dropdownTrigger => {
      dropdownTrigger.classList.remove("active");
      dropdownTrigger.nextElementSibling.setAttribute("aria-hidden", true);
    });
  }
  

  // function closeMenuOrSelectSomething(dropdownMenu) {
  //   document.addEventListener('click', e => {
  //     e.preventDefault();
  //     console.log(e.target);
  //     nodeSelectors.blogFilterContainers.forEach( container => {
  //       console.log(container);
  //       if (e.target !== container){
  //         console.log('didnt click the container');
  //       } else {
  //         console.log('cliked the container!');
          
  //       }
  //     })
  //   }, {
  //     once: true
  //   }) 
  // }

}